import cartDataLoggedHtml from './cartdatalogged.component.html';
import './cartdatalogged.component.scss';

class CartDataLoggedController {
    constructor($scope, CartService, $sce, ModalService) {
        'ngInject';
        this.$scope = $scope;
        this.service = CartService;
        this.ModalService = ModalService;
        this.$sce = $sce;
        this.countries = window.countries || ['Polska'];
    }

    $onInit() {
        this.service.step = 2;
        this.service.userLogged = true;

        this.service.loadAddresses().then(
            (addresses) => {
                for (const address of addresses.shipment) {
                    if (address.default == 1) this.setShipmentAddress(address);
                }
                for (const address of addresses.invoice) {
                    if (address.default == 1) this.setInvoiceAddress(address);
                }
            }
        );
    }

    setShipmentAddress(address) {
        this.service.data.shipmentAddressId = address.id;
    }

    setInvoiceAddress(address) {
        this.service.data.invoiceAddressId = address.id;
    }

    addNewShipmentAddress() {
        const modalRef = this.ModalService.add(
            'Dodaj nowy adres wysyłkowy',
            `<cart-add-new-address type="1" country="${this.service.summary.country}"></cart-add-new-address>`,
            (address) => {
                if (!address) return;

                const newAddress = {
                    id: address.id,
                    name: address.data.addressName,
                    first_name: address.data.firstName,
                    last_name: address.data.lastName,
                    company: address.data.companyName,
                    tax_id: address.data.taxNumber,
                    country: address.data.country,
                    zip: address.data.zipCode,
                    city: address.data.city,
                    city: address.data.city,
                    address1: address.data.street,
                    address2: `${address.data.houseNumber} ${address.data.flatNumber}`,
                    default: 0
                }

                this.service.addresses.shipment.push(newAddress);

                this.setShipmentAddress(newAddress);

                console.log(address);
            }
        );

        modalRef.open();
    }

    addNewInvoiceAddress() {
        const modalRef = this.ModalService.add(
            'Dodaj nowy adres do faktury',
            `<cart-add-new-address type="0"></cart-add-new-address>`,
            (address) => {
                if (!address) return;

                const newAddress = {
                    id: address.id,
                    name: address.data.addressName,
                    first_name: address.data.firstName,
                    last_name: address.data.lastName,
                    company: address.data.companyName,
                    tax_id: address.data.taxNumber,
                    country: address.data.country,
                    zip: address.data.zipCode,
                    city: address.data.city,
                    city: address.data.city,
                    address1: address.data.street,
                    address2: `${address.data.houseNumber} ${address.data.flatNumber}`,
                    default: 0
                }

                this.service.addresses.invoice.push(newAddress);

                this.setInvoiceAddress(newAddress);

                console.log(address);
            }
        );

        modalRef.open();
    }

    updateInvoiceSelection(type) {
        if (type === 'invoice' && this.service.data[type]) {
            this.service.data.invoice_natural_person = false;
        }

        if (type === 'invoice_natural_person' && this.service.data[type]) {
            this.service.data.invoice = false;
        }
    }
}

let cartDataLoggedComponent = {
    bindings: {},
    template: cartDataLoggedHtml,
    controller: CartDataLoggedController
}

export default cartDataLoggedComponent;